import logo from "./logo.svg";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

function App() {
  const [qps, setQps] = useState([]);
  
  const navigate = useNavigate();
  useEffect(() => {
    axios.get("/all_qp_by_name").then((res) => {
      console.log(res.data);
      setQps(res.data);
    });
  }, []);

  return (
    <div className="h-screen">
      <div className="text-center pt-[10vh]">
        <button
          onClick={() => navigate("/qp-interface")}
          className="text-3xl bg-purple-400 rounded-lg p-2 text-white font-bold"
        >
          Create Question Paper
        </button>
      </div>
      <p className="text-3xl font-semibold py-4">All Question Papers</p>
      <div className="text-center pt-4 flex flex-row first-letter:">
      {qps.map((e) => {
        return (
          <>  
            <button
              onClick={()=> {navigate(`/qp-view/${e.id}`)}}
              className="max-w-sm p-6 m-2 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
            >
              <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                {e.name}
              </h5>
              <button className="p-1 bg-yellow-200">{e.type}</button>
              <p className="font-normal text-gray-700 dark:text-gray-400">
                {e.year}
              </p>
              <button className="p-2 bg-cyan-500 text-white rounded-md">Open Paper</button>
            </button>
          </>
        );
      })}
      </div>
      
    </div>
  );
}

export default App;
